import(/* webpackMode: "eager" */ "/home/runner/work/papyrus-index/papyrus-index/node_modules/.pnpm/next@16.1.1_@babel+core@7.28.5_babel-plugin-react-compiler@19.1.0-rc.3_react-dom@19.2.3_e25d74e1e736a7fd5bb87f38e7c6e782/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/papyrus-index/papyrus-index/src/app/[game]/GameLayout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["GameDropdown"] */ "/home/runner/work/papyrus-index/papyrus-index/src/app/components/nav-bar/GameDropdown.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/papyrus-index/papyrus-index/src/app/components/nav-bar/NavBar.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NavBarSearchBarClient"] */ "/home/runner/work/papyrus-index/papyrus-index/src/app/components/nav-bar/NavBarSearchBarClient.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/papyrus-index/papyrus-index/src/app/components/wiki-attribution/WikiAttribution.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SearchProvider","LOADING_IN_DEV_MODE"] */ "/home/runner/work/papyrus-index/papyrus-index/src/app/search/SearchProvider.tsx");
